import { COMPANY } from "@/data/company";

const clip = (text, max = 158) => {
  const clean = (text || "").replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max - 1);
  return `${cut.slice(0, cut.lastIndexOf(" "))}…`;
};

export const SEO = {
  home: {
    title: "Cosmetici e igiene per anziani e pelle matura | Perfero",
    description: "Perfero è la linea di cura quotidiana pensata per la pelle matura e la terza età: detersione, trattamento e igiene con postbiotici dell'elicriso.",
  },
  shop: {
    title: "Prodotti per pelle matura e igiene degli anziani | Perfero",
    description: "Dieci prodotti per la pelle che ha vissuto: bagno doccia, crema e balsamo corpo, shampoo, detergente intimo, deodorante, salviette e pannoloni per adulti.",
  },
  contacts: {
    title: "Contatti Perfero · Lamonì Lab srl, Roma",
    description: `Telefono, email, PEC e sede legale di ${COMPANY.name} a Roma, l'azienda dei prodotti Perfero per la pelle matura. Scrivici per informazioni su prodotti e ordini.`,
  },
  privacy: { title: "Privacy policy | Perfero", description: "Come Perfero e Lamonì Lab srl trattano i tuoi dati personali: quali dati raccogliamo, perché, per quanto tempo e quali sono i tuoi diritti." },
  cookie: { title: "Cookie policy | Perfero", description: "Quali cookie e strumenti simili usa il sito Perfero, a cosa servono, quanto durano e come puoi cambiare le tue preferenze in qualsiasi momento." },
  termini: { title: "Termini e condizioni di vendita | Perfero", description: "Condizioni generali di vendita dei prodotti Perfero: prezzi, pagamento, spedizione, diritto di recesso, garanzia legale e assistenza clienti." },
  private: { title: "Perfero", noindex: true },
};

export const productSeo = (p) => {
  const title = p.category === "Corpo" ? `${p.name} per pelle matura | Perfero` : `${p.name} | Perfero`;
  return {
    title: title.length <= 60 ? title : `${p.name} | Perfero`,
    description: clip(`${p.name} ${p.size}: ${(p.tagline || "").toLowerCase()}. ${p.story || ""}`),
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Product",
      name: p.name,
      description: clip(p.story, 300),
      category: p.category,
      brand: { "@type": "Brand", name: "Perfero" },
      offers: {
        "@type": "Offer",
        price: Number(p.price).toFixed(2),
        priceCurrency: "EUR",
        availability: p.stock > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
        seller: { "@type": "Organization", name: COMPANY.name },
      },
      ...(p.rating_count > 0 && {
        aggregateRating: { "@type": "AggregateRating", ratingValue: p.rating_average, reviewCount: p.rating_count, bestRating: 5, worstRating: 1 },
      }),
    },
  };
};
